import { Tooltip } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"

import { color } from "../../../atoms/colors"

export const HubToolTip = withStyles(() => ({
  tooltip: {
    backgroundColor: `${color.common.white}`,
    color: `${color.oxfordBlue[700]}`,
    fontSize: 16,
    boxShadow:
      "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);",
    fontFamily: "Avenir",
    padding: 16,
    marginBottom: -2,
  },
  arrow: {
    color: `${color.common.white}`,
  },
}))(Tooltip)
